import React, {useState, useEffect} from "react";
import {ButtonWithIcon} from "../../styles/Butttons";
import {ReactComponent as PdfIcon} from "../../assets/icons/pdf.svg";
import ShowUserModal from "./components/ShowModal";
import {LoadComponet} from "../../components/loaders/Loader";
import Table from "../../components/table/Tables";
import DeleteModal from "../../components/modals/DeleteModal";
import {ListUserService} from "../../services/UserServices";

export default function UsersView({theme}) {
   const [deleteUser, setDeleteUser] = useState({isOpen: false, id: "", url: ""});
   const [showUser, setShowUser] = useState({isOpen: false, data: {}});
   const [isLoading, setIsLoading] = useState({data: true, view: false});
   const [data, setData] = useState([]);

   useEffect(() => {
      getData();
   }, []);

   const getData = () => {
      ListUserService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            console.log(resp);
            if (status === "error") throw new Error("Error al recuperar los usuarios");
            console.log(data);

            let newData = data.map((item) => {
               return {...item, name: `${item.userName} ${item.userLastName}`};
            });
            setData(newData);
         })
         .catch((e) => console.log(e));

      setTimeout(() => {
         setIsLoading({...isLoading, data: false});
      }, 500);
   };

   const removeId = () => {
      let newUsersList = data.map((item) => {
         if (item.idUser === deleteUser.idUSer) {
            return {...item, isActive: !deleteUser.isActive};
         }
         return item;
      });
      let dat = {
         idUser: deleteUser.idUser,
         isActive: !deleteUser.isActive,
      };
      setData(newUsersList);
   };
   return (
      <>
         {/* <HeadView>
            <></>
            <>
               <ButtonWithIcon
                  text="Descargar"
                  Icon={PdfIcon}
                  right={true}
                  action={() => {
                     // acción de descargar contenido
                  }}
               />
            </>
         </HeadView> */}
         {isLoading.data ? (
            <LoadComponet isVisible={true} theme={theme} />
         ) : (
            <Table
               noDataText="No se encontraron usuarios"
               data={data}
               columns={Columns}
               theme={theme}
               showModal={(user) => setShowUser({isOpen: true, data: data.find((item) => item.idUser === user.idUser)})}
               deleteModal={(user) => setDeleteUser({isOpen: true, id: user.idUser, url: "http://freeticket.trebolbit.com/api/city/list"})}
            />
         )}

         <ShowUserModal
            isOpen={showUser.isOpen}
            close={() => {
               setShowUser({isOpen: false, data: []});
            }}
            data={showUser.data}
            theme={theme}
         />
         <DeleteModal
            isOpen={deleteUser.isOpen}
            save={removeId}
            close={() => {
               setDeleteUser({isOpen: false, id: "", url: ""});
            }}
            confirm={removeId}
         />
      </>
   );
}

const Columns = [
   {
      title: "#",
      accessor: "idUser",
      class: "idCol normal",
   },
   {
      title: "Nombre",
      accessor: "name",
      action: "show",
   },
   {
      title: "tipo de usuario",
      accessor: "rol",
   },
   {
      title: "tipo de registro",
      accessor: "registerType",
   },
   {
      title: "email",
      accessor: "email",
   },
   {
      title: "Ciudad",
      accessor: "workplace",
   },
   {
      title: "Experiencia",
      accessor: "expYears",
   },
   /* {
      title: "",
      class: "actionBtn ghost",
      component: "disable",
      accessor: "isActive",
   }, */
];
